import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    marginBottom: 16,
    "&:last-child": {
      marginBottom: 0
    }
  },
  input: {
    height: 32,
    gap: 4,
    borderRadius: 2,
    border: "1px solid #828282",
    boxSizing: "border-box",
    transition: "border 0.2s, background 0.2s",
    "&.Mui-disabled": {
      background: "#00000026",
      border: "1px solid #0000004D"
    },
    "&.Mui-readOnly": {
      background: "#0000000D !important",
      border: "none",
      "&.Mui-focused, &:hover": {
        border: "none"
      }
    },
    "&.Mui-error": {
      border: "1.5px solid #DC0000"
    },
    "&.Mui-error:hover, &.Mui-error.Mui-focused, &.Mui-focused.Mui-error, &:focus.Mui-error":
      {
        border: "2px solid #DC0000"
      },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "& input": {
      fontFamily: "Segoe UI",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: 0,
      color: "#1E1E1E",
      border: "none",
      padding: 8,
      height: 32,
      background: "transparent",
      "&.Mui-error": {
        color: "#DC0000"
      }
    },
    "& input::placeholder": {
      fontFamily: "Segoe UI",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: 0,
      color: "#6E6E6E",
      opacity: 1
    },
    "&:hover": {
      borderWidth: 2
    },
    "&.Mui-focused, &.Mui-focused:hover": {
      border: "2px solid  #0F789B"
    },
    "& input:focus": {
      caretColor: "#005F87"
    }
  },
  errorIconWrapper: {
    display: "flex",
    alignItems: "center",
    marginRight: 8
  }
}));

export default useStyles;
